module.exports = __webpack_public_path__ + "img/img3.3e38de0b.png";